import React from "react";

const CheckIcon: React.FC = () => (
	<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="11" fill="#4CAF50" strokeWidth="2" />
		<path
			d="M8 12.5L10.5 15L16 9.5"
			stroke="white"
			strokeWidth="2.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default CheckIcon;
